<template>
    <div class="public-layout">
        <div class="header" v-if="!headless">
            <div class="container">
                <div class="top">
                    <img src="/images/dfc-logo.svg" class="logo" alt="">
                    <ul class="menu">
                        <li>
                            <a href="#">Teachers</a>
                            <ul class="submenu">
                                <li><a href="https://www.designforchange.us/for-teachers">Teachers</a></li>
                                <li><a href="https://www.designforchange.us/web-platform">Web Platform</a></li>
                                <li><a href="https://www.designforchange.us/teach-social-issues">Social Issues</a></li>
                                <li><a href="https://www.designforchange.us/professional-development">Professional Development</a></li>
                                <li><a href="https://www.designforchange.us/warmups">Empathy Warmups</a></li>
                                <li><a href="https://www.designforchange.us/register">Join Us</a></li>
                            </ul>
                        </li>
                        <li>
                            <a href="#">Students & Parents</a>
                            <ul class="submenu">
                                <li><a href="https://www.designforchange.us/for-students">Students & Parents</a></li>
                                <li><a href="https://www.designforchange.us/how-you-can-create-change">Get Started</a></li>
                                <li><a href="https://www.designforchange.us/featured-projects">Featured Projects</a></li>
                            </ul>
                        </li>
                        <li><a href="https://www.designforchange.us/partner-with-us">Partner with us</a></li>
                        <li><a href="https://www.designforchange.us/resources">Resources</a></li>
                        <li>
                            <a href="#">About us</a>
                            <ul class="submenu">
                                <li><a href="https://www.designforchange.us/about-us">About Us</a></li>
                                <li><a href="https://www.designforchange.us/design-thinking">Our Methodology</a></li>
                                <li><a href="https://www.designforchange.us/our-impact">Our Impact</a></li>
                                <li><a href="https://www.designforchange.us/contact-us">Contact Us</a></li>
                            </ul>
                        </li>
                        <li><a href="https://www.designforchange.us/blog">Blog</a></li>
                    </ul>
                    <div class="actions">
                        <a href="https://www.designforchange.us/donate" class="btn btn-warmup">Donate</a>
                        <inertia-link v-if="$page.props.user"
                                      :href="route('project.dashboard', {...global_url_params})"
                                      class="btn btn-success">Dashboard</inertia-link>
                        <inertia-link v-else
                                      :href="route('register', {...global_url_params})"
                                      class="btn btn-success">Sign Up / Login</inertia-link>
                    </div>
                </div>
                <div class="page-title" v-if="$slots.title">
                    <h1><slot name="title"></slot></h1>
                </div>
            </div>
        </div>
        <slot></slot>
    </div>
</template>

<script>
export default {
    name: "PublicLayout",
    props: ['headless']
}
</script>

<style lang="scss" scoped>
.header{
    position: relative;
    z-index: 5;
    background: $secondary;
    background: linear-gradient(180deg, $secondary 0%, rgba(216,39,80,1) 28%, rgba(218,80,20,1) 100%);
    color: white;
    padding: 1.5rem 1rem;
}

.logo{
    width: 100%;
    height: auto;
    max-width: 120px;
    margin-right: 1rem;
}

.page-title{
    margin-top: 2rem;
    text-align: center;

    h1{
        font-size: 2.5rem;
        font-weight: $font-weight-bold;
    }
}

.top{
    display: flex;
    align-items: center;
}

.menu{
    display: flex;
    justify-content: space-between;
    flex-grow: 1;

    &, ul{
        list-style: none;
        padding: 0;
        margin: 0;
    }

    ul{
        position: absolute;
        top: 100%;
        left: 50%;
        transform: translateX(-50%);
        text-align: center;
        background: $secondary;
        padding: .4rem .6rem;
        z-index: 1;
        box-shadow: rgba(black, .3) 0 8px 50px, rgba(black, .1) 0 8px 6px;
        border-radius: .3rem;
        display: none;
    }

    li{
        position: relative;
        margin: 0;
        padding: 0;

        &:hover{
            > ul {
                display: block;
                animation: fade-in linear .3s;
            }
        }
    }

    a{
        display: block;
        font-weight: $font-weight-bold;
        color: white;
        white-space: nowrap;
        padding: 0.3rem 0.4rem;
        text-decoration: none;

        &:hover{
            color: darken(white, 10%);
        }
    }

    > li{
        margin: 0 0.4rem;

        > a{
            padding: .8rem 0.4rem;
        }
    }

}

.actions{
    .btn{
        border-radius: 3rem;
        margin-left: 1rem;
        font-weight: $font-weight-bold;
        padding-left: 1rem;
        padding-right: 1rem;
    }

    .btn-success{
        background: #87C51F;
    }
}


@keyframes fade-in {
    from{
        display: none;
        opacity: 0;
    }
    to{
        display: block;
        opacity: 1;
    }
}

</style>
